import { i18n } from '../../i18n'
import { getAllAttachments, getAttachmentById } from '../../api/attachments/api.js'

const menuLockStateKey = 'eamMenuLockState'

const state = {
  priorityController: true,
  appTitle: '',
  loading: false,
  error: null,
  branding: '',
  search: '',
  online: true,
  attachmentDialog: false,
  snackbar: false,
  snackbarColor: '',
  snackbarText: '',
  menuLock: null,
  oneTimeSessionController: true,
  attachments: [],
  filters: {
    DeclarerName: [],
    ResponsibleName: [],
    Status: [],
    CategoryName: [],
    DirectionName: [],
    EquipmentName: [],
    StageName: []
  },
  showfilter: false,
}

const getters = {
  priorityController: state => state.priorityController,
  showfilter: state => state.showfilter,
  search: state => state.search,
  filters: state => state.filters,
  attachments: state => state.attachments,
  isOnline(state) {
    return state.online
  },
  menuLock(state) {
    if (state.menuLock === null) {
      state.menuLock = localStorage.getItem(menuLockStateKey) === 'true'
    }
    return state.menuLock
  },
  currentLocale() {
    return i18n.locale
  },
  oneTimeSessionController: state => state.oneTimeSessionController
}

const actions = {
  async setCurrentLocale({ commit }, payload) {
    localStorage.setItem('userLocale', payload)
    commit('clearCache')
    commit('setWorkRequestData', {
      Directions: [],
      Categories: []
    })
    i18n.locale = payload
  },
  clearError({ commit }) {
    commit('clearError')
  },
  toggleMenuMiniMode({ getters, commit }) {
    commit('setMenuLock', !getters.menuLock)
  },
  async updateAttachments({ commit, getters }, payload) {
    if (getters.isAuthenticated && getters.isOnline) {
      commit('setLoading', true)
      try {
        commit('setAttachments', [])
        const files = await getAllAttachments(payload)
        commit('setAttachments', files)
        commit('setLoading', false)
      }
      catch (error) {
        commit('setError', error.message)
        commit('setLoading', false)
      }
    }
  },
  async downloadAttachment({ commit }, payload) {
    if (payload) {
      if (payload.filePath) {
        openLink(payload.filePath)
      }
      else {
        commit('setLoading', true)
        try {
          const file = await getAttachmentById(payload)
          if (file && file.filePath) {
            openLink(file.filePath)
          }
          else if (file && file.ERRORMESSAGE) {
            commit('setError', file.ERRORMESSAGE)
          }
          commit('setLoading', false)
        }
        catch (error) {
          commit('setError', error.message)
          commit('setLoading', false)
        }
      }
    }
  },
}

const mutations = {
  setPriorityController(state, payload){
    state.priorityController = payload
  },
  setMenuLock(state, payload) {
    state.menuLock = payload
    localStorage.setItem(menuLockStateKey, payload.toString())
  },
  setLoading(state, payload) {
    state.loading = payload
  },
  setError(state, payload) {
    state.error = payload
  },
  clearError(state) {
    state.error = null
  },
  setSearch(state, payload) {
    state.search = payload
  },
  setShowFilter(state, payload){
    state.showfilter = payload
  },
  setFilters(state, payload){
    state.filters = payload
  },
  setAppTitle(state, payload) {
    state.appTitle = payload
  },
  setBranding(state, payload) {
    state.branding = payload
  },
  setAttachmentDialog(state, payload) {
    state.attachmentDialog = payload
  },
  setSnackbarData(state, payload) {
    state.snackbarColor = payload.color
    state.snackbarText = payload.text
    state.snackbar = true
  },
  setSnackbar(state, payload) {
    state.snackbar = payload
  },
  setIsOnline(state, payload) {
    state.online = payload
    // eslint-disable-next-line no-console
    console.log('Online: ' + payload.toString())
    if (payload && navigator.serviceWorker && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage('replayRequests')
    }
  },
  setAttachments(state, payload) {
    state.attachments = payload
  },
  setOneTimeSessionController(state, payload){
    state.oneTimeSessionController = payload
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}

function openLink(filePath) {
  const win = window.open(filePath, '_blank')
  if (win) {
    win.focus()
  }
  else {
    alert('Для просмотра отчета разрешите всплывающие окна для приложения')
  }
}